import type { SVGProps } from 'react'

export const SendIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.6666 1.33337L9.99998 14.6667L7.33331 8.66671M14.6666 1.33337L1.33331 6.00004L7.33331 8.66671M14.6666 1.33337L7.33331 8.66671"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
